module.exports = __webpack_public_path__ + "img/right2.c69077ad.png";